'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tabs = require('../../lib/Tabs');

var _Tabs2 = _interopRequireDefault(_Tabs);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'tabs': 'Default__tabs___1Ur8h',
  'tab': 'Default__tab___1-pJG',
  'tabItem': 'Default__tabItem___xh5Kp',
  'active': 'Default__active___1EPBD',
  'collapsed': 'Default__collapsed___VOgGk'
};

var DefaultTabs = (0, _mergeThemeHoc2.default)(style)(_Tabs2.default);
DefaultTabs.displayName = 'DefaultTabs';
exports.default = DefaultTabs;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/dist/Tabs/index.js
// module id = 850
// module chunks = 4 5 8 9 14